import React from 'react'

const Map = props => (
  <svg viewBox="0 0 10 15" {...props}>
    <path
      d="M4.688 6.563a1.87 1.87 0 0 1-1.875-1.875 1.87 1.87 0 0 1 1.874-1.875 1.87 1.87 0 0 1 1.875 1.874 1.87 1.87 0 0 1-1.875 1.875m0-6.562A4.683 4.683 0 0 0 0 4.688C0 7.28 2.344 10.78 4.688 15 7.03 10.781 9.375 7.28 9.375 4.687A4.683 4.683 0 0 0 4.687 0"
      fillRule="evenodd"
      fillOpacity={0.8}
    />
  </svg>
)

export default Map



// WEBPACK FOOTER //
// ./src/components/Icons/Map.js